import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../generic/Header.generic';
import Input from '../generic/Input.generic';
import ChecklistBadge from '../generic/ChecklistBadge.generic';
import { getInstancesByDate } from '../services/Checklist.service';
import { subscribeChecklistEvents } from '../services/Realtime.service';
import { formatDateInput, showErrorToast } from '../services/Utils.service';

const TYPE_TITLES: any = { stage: 'Stages', flight: 'Flights', airport: 'Airports' };

/**
 * Checklist du jour sélectionné (par défaut aujourd'hui), groupées par type
 * d'entité. Mise à jour en direct (SSE + repli polling).
 */
const Checklist = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState<string>(formatDateInput(new Date().toISOString()));
  const [instances, setInstances] = useState<Array<any>>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const mounted = useRef<boolean>(true);

  const load = (date: string) => {
    getInstancesByDate(date).then(
      (result: any) => {
        if (mounted.current) {
          setInstances(result?.data || []);
          setLoading(false);
        }
      },
      (error: any) => {
        if (mounted.current) {
          setLoading(false);
          showErrorToast(error?.response?.data?.message || 'Unable to load checklists');
        }
      },
    );
  };

  useEffect(() => {
    mounted.current = true;
    load(selectedDate);
    const unsubscribe = subscribeChecklistEvents(() => load(selectedDate));
    return () => {
      mounted.current = false;
      unsubscribe();
    };
  }, [selectedDate]);

  const openDetail = (instanceId: number) => {
    navigate(`/checklist_detail?id=${instanceId}`);
  };

  return (
    <div className="page">
      <Header from="checklist" backUrl="/dashboard" title="Checklist"></Header>
      <Input
        type="date"
        value={selectedDate}
        customClass="basic_input mt-5 mb-5"
        onChange={(e: any) => {
          setLoading(true);
          setSelectedDate(e.target.value);
        }}></Input>

      {loading ? (
        <div className="checklist_loading">Loading…</div>
      ) : instances.length === 0 ? (
        <div className="no_data_block">
          <img src="img/details_vol.svg" alt="Icon no data" className="icon_no_data" />
          <span className="text_no_data mt-5">No checklist for this day</span>
        </div>
      ) : (
        <div className="checklist_page">
          {['stage', 'flight', 'airport'].map((type: string) => {
            const group = instances.filter((instance: any) => instance.entityType === type);
            if (group.length === 0) {
              return null;
            }
            return (
              <div className="checklist_group" key={type}>
                <h2 className="checklist_group_title">{TYPE_TITLES[type]}</h2>
                {group.map((instance: any) => (
                  <div className="checklist_row" key={instance.id} onClick={() => openDetail(instance.id)}>
                    <div className="checklist_row_main">
                      <span className="checklist_row_label">{instance.entityLabel}</span>
                      <span className="checklist_row_template">{instance.templateName || '—'}</span>
                    </div>
                    <ChecklistBadge state={instance.state}></ChecklistBadge>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Checklist;
